import { useReward } from '@/contexts/reward-context';
import { ArrowLeftIcon } from '@/components/svg-icons';

export const TopBar = ({ 
	onClose 
}: {
	onClose: () => void;
}) => {
	const { labels } = useReward();

	return (
		<div className="reward-top-bar">
			<div 
				className="reward-top-bar__back"
				onClick={onClose}
			>
				<ArrowLeftIcon />
			</div>
			<div className="reward-top-bar__title">{labels?.lbl_RPRulesRegulation}</div>
		</div>
	);
};